import { compose } from 'recompose';
import AnswerForMessage from './answerForMessage';

const enhance = compose(
);
export default enhance(AnswerForMessage);
